import { Job, JobType, ShippingMode } from "@/common/apis/dtos";
import { CustomsSummary } from "./CustomsSummary";
import { SurfaceCarrierSummary } from "./SurfaceCarrierSummary";

declare interface TrackingSummaryProps {
  shipment: Job;
  isMobileScreen: boolean;
}
export const TrackingSummary = ({ shipment, isMobileScreen }: TrackingSummaryProps) => {
  const showCustomsSummary = shipment.mode === ShippingMode.Truckload || shipment.mode === ShippingMode.Ocean;
  const showCarrierSummary = !showCustomsSummary && shipment.jobType === JobType.Shipment;

  if (showCustomsSummary && shipment?.customsStatus) {
    return (
      <CustomsSummary 
        customsStatus={shipment.customsStatus} 
        destinationDate={shipment.dispositionDate} 
        isMobileScreen={isMobileScreen} 
      />
    );
  }

  if (showCarrierSummary) {
    return (
      <SurfaceCarrierSummary 
        shipment={shipment} 
        isMobileScreen={isMobileScreen} 
      />
    );
  }

  return <></>;
}